/*
 * Attention spans both sides of the panel — the order pipeline derived on the
 * client and the setup checks that arrive from the server — so it is assembled
 * here rather than in either source.
 */

// The badge counts problems, not rows: forty-five overdue orders is one thing to
// look at, not forty-five. Each item still carries its own count for display.
const QUEUES = [
  {
    id: "image_approvals",
    label: "Image approvals pending",
    key: "imageApprovalsPending",
  },
  { id: "overdue", label: "Orders overdue", key: "overdue" },
];

const queueItems = (orders) =>
  QUEUES.map(({ id, label, key }) => ({
    id,
    label,
    count: Number(orders?.[key] ?? 0),
  })).filter((item) => item.count > 0);

const setupItems = (setup) =>
  (setup?.checks ?? [])
    .filter((check) => check.status === "fail")
    .map((check) => ({
      id: `setup_${check.id}`,
      label: check.message,
      count: null,
    }));

export const attentionItems = ({ orders, setup }) => [
  ...queueItems(orders),
  ...setupItems(setup),
];

export const attention = (payload) => {
  const items = attentionItems(payload);

  return { count: items.length, items };
};

export default { attention, attentionItems };
